import React from 'react';
import PropTypes from 'prop-types';

export default class DocTitle extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    addToPrevious: PropTypes.bool,
  };
  static contextTypes = {
    setDocTitle: PropTypes.func,
  };

  buildTitleWithPrevious = docTitle => previousTitle => {
    return `${docTitle}${previousTitle}`;
  };

  componentWillMount() {
    const { title = '', addToPrevious } = this.props;
    let newTitle = title;

    if (addToPrevious) {
      const docTitle = title ? `${title} | ` : '';
      newTitle = this.buildTitleWithPrevious(docTitle);
    }
    this.context.setDocTitle(newTitle);
  }

  componentWillReceiveProps(nextProps) {
    const { title = '', addToPrevious } = nextProps;

    if (this.props.title !== title) {
      let newTitle = title;

      if (addToPrevious) {
        const docTitle = title ? `${title} | ` : '';
        newTitle = this.buildTitleWithPrevious(docTitle);
      }
      this.context.setDocTitle(newTitle);
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/StandardPageTemplate/Context/DocTitle.js